"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MIN_BATCH_SIZE = 100;
const MAX_BATCH_SIZE = 10000;
class BatchEventProcessor {
    constructor(eventQueue, batchSize) {
        this.eventQueue = eventQueue;
        // clamp batch size between min and max
        this.batchSize = Math.max(MIN_BATCH_SIZE, Math.min(MAX_BATCH_SIZE, batchSize));
    }
    nextBatch() {
        return this.eventQueue.splice(this.batchSize);
    }
    push(...events) {
        this.eventQueue.push(...events);
    }
    isEmpty() {
        return this.eventQueue.isEmpty();
    }
}
exports.default = BatchEventProcessor;
//# sourceMappingURL=batch-event-processor.js.map